import { put, takeLatest, call } from 'redux-saga/effects'

import { UpdateOrder } from '../../../services/orderService'
import {
  UPDATE_ORDER,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_ERROR
}
  from '../../actions/order'

function * updateOrderSaga (action) {
  try {
    const data = yield call(UpdateOrder, action.payload)

    yield put({
      type: UPDATE_ORDER_SUCCESS,
      payload: data
    })
  } catch (error) {
    yield put({
      type: UPDATE_ORDER_ERROR, error: error.data
    })
  }
}

export function * updateOrderSagaWatcher () {
  yield takeLatest(UPDATE_ORDER, updateOrderSaga)
}
